"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _onSwipeBack = _interopRequireDefault(require("../onSwipeBack"));
var _nativeAdapter = _interopRequireDefault(require("@zz-common/native-adapter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function useBetterSwipeBack(observeConfig) {
  if (!_nativeAdapter.default.in('zz') && !_nativeAdapter.default.in('zlj')) return;
  var UA = window.navigator.userAgent;
  var isIOS = !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  // popup实例
  var observeInstance = [];
  // 是否允许侧滑返回： 0禁止 1允许
  var slipStatus = 1;
  var setPageGestureBackAction = function setPageGestureBackAction(status) {
    slipStatus = status;
    //找靓机侧的侧滑使用老的api--openBlockBack
    if (isIOS && _nativeAdapter.default.in('zlj')) {
      _nativeAdapter.default.wrap('openBlockBack')(!status);
    } else {
      status ? _nativeAdapter.default.wrap('cancelStopBack')(function () {
        console.warn('解除物理键返回锁定');
      }) : _nativeAdapter.default.wrap('stopBack')(function (res) {
        console.warn('锁定物理键返回锁定');
        if (+res.code === 0) {
          swipeBackCallback();
        }
      });
    }
  };
  // 注册侧滑返回监听事件
  var swipeBackCallback = function swipeBackCallback(handler) {
    var visibileInstance = observeInstance.filter(function (v) {
      return v.$el.style.display !== 'none';
    }).sort(function (a, b) {
      return a.$el.style.zIndex > b.$el.style.zIndex ? -1 : 0;
    });
    if (visibileInstance.length) {
      try {
        ;
        visibileInstance[0].$parent.close();
        handler === null || handler === void 0 ? void 0 : handler.removeEventListener();
      } catch (e) {}
    }
  };

  // 注册监听事件
  var registerObserver = function registerObserver(el) {
    // 监听回调
    var onPopupChange = function onPopupChange() {
      try {
        // 是否有显示中的popup
        var hasVisibleInstance = false;
        observeInstance.forEach(function (instance) {
          var _style;
          if (((_style = instance.$el.style) === null || _style === void 0 ? void 0 : _style.display) !== 'none') {
            hasVisibleInstance = true;
          }
        });
        // 如果有popup显示，且没有阻止关闭，则阻止
        if (hasVisibleInstance && slipStatus) {
          console.warn('阻止侧滑');
          setPageGestureBackAction(0);
        } else if (!hasVisibleInstance && !slipStatus) {
          // 如果没有popop显示，且阻止了关闭，则打开
          setTimeout(function () {
            console.warn('允许侧滑');
            setPageGestureBackAction(1);
          }, 500);
        }
        // 如果有popup显示，注册侧滑返回监听动作
        if (hasVisibleInstance) {
          (0, _onSwipeBack.default)(swipeBackCallback);
        }
      } catch (e) {}
    };

    // 监听属性变化
    var observer = new MutationObserver(onPopupChange);
    observer.observe(el, {
      attributes: true
    });
  };
  _vue.default.mixin({
    mounted: function mounted() {
      var _this = this;
      try {
        // 如果是zzui的popup组件
        if (this.name && (Array.isArray(observeConfig) && observeConfig.find(function (name) {
          return _this.name.indexOf(name) === 0;
        }) || this.name.indexOf('z-popup') === 0)) {
          // 保存dom实例
          observeInstance.push(this);
          // 注册监听事件
          registerObserver(this.$el);
        }
      } catch (e) {}
    }
  });
}
var _default = useBetterSwipeBack;
exports.default = _default;